import React from "react";
import GlobalFooter from "components/GlobalFooter";

export default function LandingFooter() {
  return <GlobalFooter />;
}